import { render, staticRenderFns } from "./ZhuantiTitleBlock.vue?vue&type=template&id=476ebc05&scoped=true"
import script from "./ZhuantiTitleBlock.vue?vue&type=script&lang=js"
export * from "./ZhuantiTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhuantiTitleBlock.vue?vue&type=style&index=0&id=476ebc05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ebc05",
  null
  
)

export default component.exports